module.exports = __webpack_public_path__ + "static/media/KochiTuskersKeralaLogo.cebd62db.png";